<template>
    <CardPage :section="13" :page="7" :nextDisabled="nextDisabled" ref="cardPage">
        <div>
            <p>
                What are the positive and negative aspects of the relationship? Select positive or negative for each below.
            </p>
            <p class="font-weight-bold" v-if="currentQuizItem">
                <v-fade-transition mode="out-in">
                    <span :key="currentQuizItem.text">{{ currentQuizItem.text }}</span>
                </v-fade-transition>
            </p>
            <p v-else class="font-weight-bold font-italic">You've answered everything!</p>
            <v-btn block round color="primary" @click="answer('positive')" :disabled="!currentQuizItem">Positive</v-btn>
            <v-btn block round color="primary" @click="answer('negative')" :disabled="!currentQuizItem">Negative</v-btn>
        </div>
        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        quiz: get('section13/quiz'),
        currentQuizItem: get('section13/currentQuizItem')
    },
    methods: {
        answer(answer) {
            if (this.currentQuizItem.correctAnswer === answer) {
                this.$refs.modalFeedback.show(true, 'Good job!', () => {
                    this.$store.set(`section13/quiz@${this.currentQuizItem.id}.answered`, true);
                    if (!this.nextDisabled()) {
                        this.$refs.cardPage.nextClick();
                    }
                });
            } else {
                this.$refs.modalFeedback.show(false, 'Try again!');
            }
        },
        nextDisabled() {
            return !!this.currentQuizItem;
        }
    }
};
</script>
